import * as React from 'react';
import { PersonInfoForm } from "../components/PersonInfoForm";
import { momentAgeNow } from 'src/share/utils/utils';
import { Row, Col } from 'reactstrap';
import { WrappedInput } from 'src/share/components/Input/Input';
import { Sexs } from 'src/share/types/common';
import ImageDropZone from 'src/share/components/ImageDropZone/ImageDropZone';

const AdvancedLayout = (props: { that: PersonInfoForm; index: number, person: any }) => (
    <Row className="person margin-forms">
        <Header {...props} />
        <Images {...props} />
        <Name {...props} />
        <Date {...props} />
        <Sex {...props} />
        <Weight {...props} />
        <Height {...props} />
        <EyeColor {...props} />
        <HairColor {...props} />
        <MissingDateCompanionType {...props} />
    </Row>
)


export const PersonLayout = (props) => {
    const that: PersonInfoForm = props.that;
    const person = props.person;
    const personId = that.props.type === 'child' ? person.childId : person.abductorId;
    person.age = person.birthDate ? momentAgeNow(person.birthDate) : "";
    return <AdvancedLayout key={personId} {...props} />
}





const Header = ({ that, index, person }: { that: PersonInfoForm, index: number, person: any }) => {
    const name = that.props.personsInfo[index].fullName;
    const personId = that.props.type === 'child' ? person.childId : person.abductorId;
    return (
        <Col className={"col-12 header-person"}>
            <h6>
                {name ? name : "\xa0"}
                {
                    (!that.state.isChild || that.props.personsInfo.length > 1) &&
                    <i className="fa fa-trash" aria-hidden="true" onClick={() => that.props.removePerson(personId, that.props.type)} />
                }
            </h6>
        </Col>
    )
}


const Name = ({ that, index }) => <WrappedInput md={12} key={"person-name"} type="text" className="name-person" placeholder="Enter full name" {...that.form(index, 'fullName', false)} required={true} labeltext={that.props.isEdit ? 'Full Name' : ''} />
const Date = ({ that, index }) => (
    <>
        <WrappedInput className="no-padding-right hw" md={5} type="number" placeholder="Age" {...that.form(index, 'age', false)} {...that.getBirthDatebyAge(index)} labeltext={that.props.isEdit ? 'Age' : ''} />
        <WrappedInput className="no-padding-left" md={7} type="date" placeholder="Birth Date"  {...that.form(index, 'birthDate', false)} {...that.getAgeByBirthDate(index)} labeltext={that.props.isEdit ? 'Birthdate' : ''} />
    </>
)
const Sex = ({ that, index }) => (
    <WrappedInput {...that.form(index, 'sex')} type="select" placeholder="Sex" labeltext={that.props.isEdit ? 'Sex' : ''} >
        <option value="">Sex</option>
        <option value={Sexs.Male}>{Sexs.Male}</option>
        <option value={Sexs.Female}>{Sexs.Female}</option>
        <option value={Sexs.Unknown}>{Sexs.Unknown}</option>
    </WrappedInput>
)
const Images = ({ that, index }) => (
    <Row className={"images"}>
        <Col className="col-4">
            <ImageDropZone {...that.imageHandler(index, 0)} />
        </Col>
        <Col className="col-4">
            <ImageDropZone {...that.imageHandler(index, 1)} />
        </Col>
        <Col className="col-4">
            <ImageDropZone {...that.imageHandler(index, 2)} />
        </Col>
    </Row>
)
const Weight = ({ that, index }) => (
    <>
        <WrappedInput className="no-padding-right hw" sm="12" md="5" type="select" placeholder="Unit" {...that.form(index, 'weightUnit', false)}
            {...that.unitValidationFields(index, 'weight')} labeltext={that.props.isEdit ? 'Unit' : ''} >
            <option value="">Select</option>
            <option value="lbs">lbs</option>
            <option value="kgs">kgs</option>
        </WrappedInput>
        <WrappedInput className="no-padding-left" sm="12" {...that.form(index, 'weight', false)} md={7} type="number" placeholder="Weight" min={5} max={250}
            {...that.unitValueValidationFields(index, 'weight')} labeltext={that.props.isEdit ? 'Weight' : ''} />

    </>
)
const Height = ({ that, index }) => (
    <>
        <WrappedInput className="no-padding-right hw" md="5" type="select" placeholder="Unit" {...that.form(index, 'heightUnit', false)}
            {...that.unitValidationFields(index, 'height')} labeltext={that.props.isEdit ? 'Unit' : ''} >
            <option value="">Select</option>
            <option value="ft">ft</option>
            <option value="cms">cms</option>
        </WrappedInput>
        <WrappedInput className="no-padding-left" {...that.form(index, 'height', false)} md={7} type="text" placeholder="Height"
            {...that.unitValueValidationFields(index, 'height')} labeltext={that.props.isEdit ? 'Height' : ''} />
    </>
)
const EyeColor = ({ that, index }) => <WrappedInput md={12} type="text" placeholder="Eye Color" {...that.form(index, 'eyeColor', false)} labeltext={that.props.isEdit ? 'Eye Color' : ''} />
const HairColor = ({ that, index }) => <WrappedInput md={12} type="text" placeholder="Hair Color" {...that.form(index, 'hairColor', false)} labeltext={that.props.isEdit ? 'Hair Color' : ''} />
const MissingDateCompanionType = ({ that, index }) => {
    return that.state.isChild ?
        <></>
        :
        <WrappedInput id="companionOptionsDropdown" type="select" md={12} placeholder="Companion Type" {...that.form(index, ('companionType'))} labeltext={that.props.isEdit ? 'Companion Type' : ''} >
            <option value="">Select One...</option>
            {that.getCompanionTypeOptions()}
        </WrappedInput>
}

